import { render, staticRenderFns } from "./LegalCompanies.vue?vue&type=template&id=7f801f8c"
import script from "./LegalCompanies.vue?vue&type=script&lang=js"
export * from "./LegalCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports